import { Assistants } from '../translations-types';

const translations: Assistants = {
  successfullyUpdatedAssistantsSettings: 'Assistent instellingen succesvol aangepast',
  creditsOptions: 'Assistent krediet aankoop opties',
  creditsBalance: 'Assistent krediet balans',
  insufficientCredits: 'Onvoldoende krediet. Beschikbaar: {{available}}, benodigd: {{required}}. ',
  noAssistants: 'Geen assistenten Beschikbaar.',
};

export default translations;
